import { cx } from "@jugl-web/utils";
import { CSSProperties, FC, ReactNode } from "react";

export interface ScrollablePageProps {
  children: ReactNode;
  /**
   * Minimum content width in pixels. Below this width the page scrolls
   * horizontally instead of shrinking. Defaults to 1024.
   */
  minWidth?: number;
  /** Disables the default horizontal scroll; content can shrink freely. */
  isDisabled?: boolean;
}

const DEFAULT_MIN_WIDTH_PX = 1024;

/**
 * Keeps page content usable on narrow viewports by preventing it from
 * shrinking below a minimum width and scrolling horizontally instead.
 */
export const ScrollablePage: FC<ScrollablePageProps> = ({
  children,
  minWidth = DEFAULT_MIN_WIDTH_PX,
  isDisabled = false,
}) => {
  const innerStyle: CSSProperties | undefined = isDisabled
    ? undefined
    : { minWidth };

  return (
    <div
      className={cx(
        "h-full w-full",
        !isDisabled && "jugl__custom-scrollbar overflow-x-auto"
      )}
    >
      <div className="h-full" style={innerStyle}>
        {children}
      </div>
    </div>
  );
};
